// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700&family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_mediumWhite__v0A-4 {
  font-size: 16px;
  color: #fff;
  margin-bottom: 0;
  line-height: 28px;
}

.style_extraSmallLight__kD3e3 {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 22px;
  margin-bottom: 0;
}

.style_extraSmallWhite__IZOYi {
  font-size: 12px;
  color: #fff;
  line-height: 22px;
  margin-bottom: 0;
}

.style_smallLight__jubVU {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 22px;
  margin-bottom: 0;
}

.style_smallWhite__MwyDU {
  font-size: 14px;
  color: #fff;
  line-height: 22px;
  margin-bottom: 0;
}

.style_smallRed__f4vE8 {
  font-size: 14px;
  color: #d41313;
  line-height: 22px;
  margin-bottom: 0;
}

.style_mediumLight__\\+8ve4 {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 22px;
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/Shared/Text/style.module.scss","webpack://./src/Assets/Scss/veriables.scss"],"names":[],"mappings":"AAEA;EACE,eCqCQ;EDpCR,WCGM;EDFN,gBAAA;EACA,iBAAA;AACF;;AACA;EACE,eC4BQ;ED3BR,+BCFW;EDGX,iBAAA;EACA,gBAAA;AAEF;;AAAA;EACE,eCsBQ;EDrBR,WCTM;EDUN,iBAAA;EACA,gBAAA;AAGF;;AADA;EACE,eCiBQ;EDhBR,+BCdW;EDeX,iBAAA;EACA,gBAAA;AAIF;;AAFA;EACE,eCWQ;EDVR,WCrBM;EDsBN,iBAAA;EACA,gBAAA;AAKF;;AAHA;EACE,eCKQ;EDJR,cCxBI;EDyBJ,iBAAA;EACA,gBAAA;AAMF;;AAJA;EACE,eCCQ;EDAR,+BChCW;EDiCX,iBAAA;EACA,gBAAA;AAOF","sourcesContent":["@import \"../../Assets/Scss/veriables.scss\";\n\n.mediumWhite {\n  font-size: $font-16;\n  color: $white;\n  margin-bottom: 0;\n  line-height: 28px;\n}\n.extraSmallLight {\n  font-size: $font-12;\n  color: $light-gray;\n  line-height: 22px;\n  margin-bottom: 0;\n}\n.extraSmallWhite {\n  font-size: $font-12;\n  color: $white;\n  line-height: 22px;\n  margin-bottom: 0;\n}\n.smallLight {\n  font-size: $font-14;\n  color: $light-gray;\n  line-height: 22px;\n  margin-bottom: 0;\n}\n.smallWhite {\n  font-size: $font-14;\n  color: $white;\n  line-height: 22px;\n  margin-bottom: 0;\n}\n.smallRed {\n  font-size: $font-14;\n  color: $red;\n  line-height: 22px;\n  margin-bottom: 0;\n}\n.mediumLight {\n  font-size: $font-16;\n  color: $light-gray;\n  line-height: 22px;\n  margin-bottom: 0;\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700&family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n$font-family: \"Poppins\" !default;\n$font-family-Roboto: \"Roboto\" !default;\n$font-family-Dosis: \"Dosis\" !default;\n\n$white: #fff !default;\n$light-gray: rgba(255, 255, 255, 0.5) !default;\n\n$red: #d41313 !default;\n\n$primary: #0575E6 !default;\n\n$black: #131313 !default;\n$light-black: #201f23 !default;\n$dark-black: #0e0e0e !default;\n$blue: #0575E6 !default;\n$gray: Gray !default;\n$lightgray: lightgray !default;\n$green: #42D742 !default;\n\n\n$border: 1px solid #D1D1D1 !default;\n$bold-border: 3px solid #b59b41 !default;\n\n$border-radius-10: 10px !default;\n$border-radius-20: 20px !default;\n$border-radius-24: 24px !default;\n\n$text-uppercase: uppercase !default;\n\n\n$font-8: 8px !default;\n$font-9: 9px !default;\n$font-10: 10px !default;\n$font-11: 11px !default;\n$font-12: 12px !default;\n$font-14: 14px !default;\n$font-15: 15px !default;\n$font-16: 16px !default;\n$font-17: 17px !default;\n$font-18: 18px !default;\n$font-20: 20px !default;\n$font-22: 22px !default;\n$font-24: 24px !default;\n$font-26: 26px !default;\n$font-28: 28px !default;\n$font-32: 32px !default;\n$font-36: 36px !default;\n$font-50: 50px !default;\n$font-40: 40px !default;\n$font-144: 144px !default;\n\n$font-weight-300: 300 !default;\n$font-weight-400: 400 !default;\n$font-weight-500: 500 !default;\n$font-weight-600: 600 !default;\n$font-weight-700: 700 !default;\n$font-weight-800: 800 !default;\n$font-weight-900: 900 !default;\n$font-weight-1200: 1900 !default;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mediumWhite": `style_mediumWhite__v0A-4`,
	"extraSmallLight": `style_extraSmallLight__kD3e3`,
	"extraSmallWhite": `style_extraSmallWhite__IZOYi`,
	"smallLight": `style_smallLight__jubVU`,
	"smallWhite": `style_smallWhite__MwyDU`,
	"smallRed": `style_smallRed__f4vE8`,
	"mediumLight": `style_mediumLight__+8ve4`
};
export default ___CSS_LOADER_EXPORT___;
